export default __webpack_public_path__ + "static/media/phantom.64ba3400.png";